export const settings = {
  dots: true,
  arrows: true,
  infinite: false,
  speed: 500,
  cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  // Continuous stripe: advance one card at a time (not a full row of 3).
  slidesToScroll: 1,
  slidesToShow: 3,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};
